export default {
  pt: {
    'components.observacaoAlertDialog.titleActive': 'Observação ativa',
    'components.observacaoAlertDialog.titleAdd': 'Adicionar observação',
    'components.observacaoAlertDialog.noText': 'Sem texto.',
    'components.observacaoAlertDialog.openedBy': 'Aberta por {{name}}',
    'components.observacaoAlertDialog.openedByAt': 'Aberta por {{name}} em {{date}}',
    'components.observacaoAlertDialog.userFallback': 'usuário',
    'components.observacaoAlertDialog.description': 'O alerta destaca a linha em azul até a pendência ser resolvida. Descreva o motivo abaixo.',
    'components.observacaoAlertDialog.notesLabel': 'Observações',
    'components.observacaoAlertDialog.wait': 'Aguarde…',
    'components.observacaoAlertDialog.resolveAlert': 'Resolver alerta',
    'components.observacaoAlertDialog.activateAlert': 'Ativar alerta',
  },
  en: {
    'components.observacaoAlertDialog.titleActive': 'Active note',
    'components.observacaoAlertDialog.titleAdd': 'Add note',
    'components.observacaoAlertDialog.noText': 'No text.',
    'components.observacaoAlertDialog.openedBy': 'Opened by {{name}}',
    'components.observacaoAlertDialog.openedByAt': 'Opened by {{name}} on {{date}}',
    'components.observacaoAlertDialog.userFallback': 'user',
    'components.observacaoAlertDialog.description': 'The alert highlights the row in blue until the issue is resolved. Describe the reason below.',
    'components.observacaoAlertDialog.notesLabel': 'Notes',
    'components.observacaoAlertDialog.wait': 'Please wait…',
    'components.observacaoAlertDialog.resolveAlert': 'Resolve alert',
    'components.observacaoAlertDialog.activateAlert': 'Activate alert',
  },
  es: {
    'components.observacaoAlertDialog.titleActive': 'Observación activa',
    'components.observacaoAlertDialog.titleAdd': 'Añadir observación',
    'components.observacaoAlertDialog.noText': 'Sin texto.',
    'components.observacaoAlertDialog.openedBy': 'Abierta por {{name}}',
    'components.observacaoAlertDialog.openedByAt': 'Abierta por {{name}} el {{date}}',
    'components.observacaoAlertDialog.userFallback': 'usuario',
    'components.observacaoAlertDialog.description': 'La alerta resalta la fila en azul hasta que se resuelva la incidencia. Describa el motivo abajo.',
    'components.observacaoAlertDialog.notesLabel': 'Observaciones',
    'components.observacaoAlertDialog.wait': 'Espere…',
    'components.observacaoAlertDialog.resolveAlert': 'Resolver alerta',
    'components.observacaoAlertDialog.activateAlert': 'Activar alerta',
  },
}
